import React from "react";
import Slider from 'react-slick';
import IconInstacartIntegration from "../../icons/iocn-instacart.svg";
import IconHTFuelPoints from "../../icons/icon-ht-fuelpoints.svg";
import IconRushDelivery from "../../icons/icon-uber.svg";
import IconDeliveryNotifications from "../../icons/icon-delivery-notification.svg";
import IconMobilePayments from "../../icons/icon-mobile-payment.svg";
import IconFreshFoodOrdering from "../../icons/icon-freshfood.svg";

export default function CsServices() {

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
    ]
  };

  return (
    <div className="cs-services-section section-gap">
      <div className="section-gap">
        <div className="container-small">
          <div className="col">
            <h3>Constantly shipping new digital products and services</h3>
            <p>Since 2016, we’ve launched 30+ digital products, services, and countless innovations that continue to allow Harris Teeter to be a leader in digital retail.</p>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="cs-services-slider text-center">
          <Slider {...settings}>
            <div className="services-item">
              <div className="services-icon"><IconInstacartIntegration /></div>
              <p>Instacart <br /> Integration</p>
            </div>
            <div className="services-item">
              <div className="services-icon"><IconHTFuelPoints /></div>
              <p>HT Fuel <br /> Points</p>
            </div>
            <div className="services-item">
              <div className="services-icon"><IconRushDelivery /></div>
              <p>Rush <br /> Delivery</p>
            </div>
            <div className="services-item">
              <div className="services-icon"><IconDeliveryNotifications /></div>
              <p>Delivery <br /> Notifications</p>
            </div>
            <div className="services-item">
              <div className="services-icon"><IconMobilePayments /></div>
              <p>Mobile <br /> Payments</p>
            </div>
            <div className="services-item">
              <div className="services-icon"><IconFreshFoodOrdering /></div>
              <p>Fresh Food <br /> Ordering</p>
            </div>
          </Slider>
        </div>
      </div>
    </div>
  );
}